const types = {
  SET_CLIENTS: 'SET_CLIENTS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/clients/mutations-types.js